/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendStandardProductDto } from '../../models/backend-standard-product-dto';

export interface SalesStandardProductsList$Params {
  /**
   * A search term.
   */
  search?: string;
  variant?: number;
}

export function salesStandardProductsList(
  http: HttpClient,
  rootUrl: string,
  params?: SalesStandardProductsList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendStandardProductDto>>> {
  const rb = new RequestBuilder(rootUrl, salesStandardProductsList.PATH, 'get');
  if (params) {
    rb.query('search', params.search, {});
    rb.query('variant', params.variant, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendStandardProductDto>>;
    }),
  );
}

salesStandardProductsList.PATH = '/api/sales/standard-products/';
